export default function PlanAnswerField({ field, answers, onChange }) {
  if (field.dependsOn && answers[field.dependsOn.key] !== field.dependsOn.value) return null;
  const value = answers[field.key];
  return (
    <label className="block">
      <span className="block text-sm font-bold text-hunter mb-1">{field.label}{field.required === false ? ' (optional)' : ''}</span>
      {field.type === 'boolean' ? (
        <select
          value={value === true ? 'yes' : value === false ? 'no' : ''}
          onChange={(event) => onChange(field.key, event.target.value === '' ? undefined : event.target.value === 'yes')}
          className="input"
        >
          <option value="">Choose Yes or No…</option>
          <option value="no">No</option>
          <option value="yes">Yes</option>
        </select>
      ) : (
        <textarea value={value ?? ''} onChange={(event) => onChange(field.key, event.target.value)} className="input min-h-20 resize-y text-sm" />
      )}
    </label>
  );
}
